var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chevron_2",
    d: "M14.3262 12.2174C14.3191 11.9703 14.2697 11.7445 14.178 11.5398C14.0862 11.3351 13.9451 11.1375 13.7545 10.947L3.14664 0.677883C2.84315 0.374399 2.46909 0.222656 2.02445 0.222656C1.72802 0.222656 1.45983 0.293234 1.21986 0.43439C0.972842 0.575546 0.778753 0.766106 0.637597 1.00607C0.489383 1.24604 0.415277 1.51423 0.415277 1.81066C0.415277 2.24824 0.581135 2.63289 0.912851 2.96461L10.5044 12.2068L0.912851 21.4595C0.581135 21.7983 0.415277 22.183 0.415277 22.6135C0.415277 22.917 0.489383 23.1887 0.637597 23.4287C0.778753 23.6686 0.972842 23.8592 1.21986 24.0003C1.45983 24.1485 1.72802 24.2227 2.02445 24.2227C2.46909 24.2227 2.84315 24.0674 3.14664 23.7568L13.7545 13.4878C13.9521 13.2972 14.0968 13.0996 14.1885 12.8949C14.2803 12.6832 14.3262 12.4573 14.3262 12.2174Z",
    fill: "currentcolor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.dfd4e3af1806d354530a0732773766f6.svg";
export { ForwardRef as ReactComponent };